import { gql } from '@apollo/client'

export const MUTATION_CONTACT_ADD = gql`
  mutation addContact(
    $name: String
    $subject: String
    $email: String
    $cellphone: String
    $content: String
  ) {
    addContact(
      name: $name
      subject: $subject
      email: $email
      cellphone: $cellphone
      content: $content
    )
  }
`;

export const MUTATION_LOGIN = gql`
  mutation login($username: String, $password: String) {
    login(username: $username, password: $password)
  }
`;

export const MUTATION_REGISTER = gql`
  mutation register($cellphone: String, $password: String, $name: String) {
    register(cellphone: $cellphone, password: $password, name: $name) {
      id
      name
      cellphone
    }
  }
`;

export const MUTATION_CELLPHONE_VERIFIED = gql`
  mutation cellphoneVerified($cellphone: String, $cellphone_code: String) {
    cellphoneVerified(cellphone: $cellphone, cellphone_code: $cellphone_code)
  }
`;

export const MUTATION_CELLPHONE_VERIFY_SEND = gql`
  mutation cellphoneVerifySend($cellphone: String) {
    cellphoneVerifySend(cellphone: $cellphone)
  }
`;

export const MUTATION_LOGOUT = gql`
  mutation logout {
    logout
  }
`;

export const MUTATION_CREATE_USER = gql`
  mutation createUser(
    $name: String
    $lastname: String
    $guarantor_id: Int
    $recommender_id: Int
    $id_number: String
    $id_card_number: String
    $phone: String
    $mobile: String
    $email: String
    $credit: Float
    $group_id: Int
    $username: String
    $password: String
    $address: String
    $description: String
    $father: String
    $place_of_issuance: String
    $birthday: String
    $postal_code: String
    $job: String
  ) {
    createUser(
      name: $name
      lastname: $lastname
      guarantor_id: $guarantor_id
      recommender_id: $recommender_id
      id_number: $id_number
      id_card_number: $id_card_number
      phone: $phone
      mobile: $mobile
      email: $email
      credit: $credit
      group_id: $group_id
      username: $username
      password: $password
      address: $address
      description: $description
      father: $father
      place_of_issuance: $place_of_issuance
      birthday: $birthday
      postal_code: $postal_code
      job: $job
    ) {
      id
    }
  }
`;

export const MUTATION_EDIT_USER = gql`
  mutation editUser(
    $id: Int
    $name: String
    $lastname: String
    $guarantor_id: Int
    $recommender_id: Int
    $id_number: String
    $id_card_number: String
    $phone: String
    $mobile: String
    $email: String
    $credit: Float
    $group_id: Int
    $username: String
    $password: String
    $address: String
    $description: String
    $father: String
    $place_of_issuance: String
    $birthday: String
    $postal_code: String
    $job: String
  ) {
    editUser(
      id: $id
      name: $name
      lastname: $lastname
      guarantor_id: $guarantor_id
      recommender_id: $recommender_id
      id_number: $id_number
      id_card_number: $id_card_number
      phone: $phone
      mobile: $mobile
      email: $email
      credit: $credit
      group_id: $group_id
      username: $username
      password: $password
      address: $address
      description: $description
      father: $father
      place_of_issuance: $place_of_issuance
      birthday: $birthday
      postal_code: $postal_code
      job: $job
    ) {
      id
    }
  }
`;

export const MUTATION_ADD_CAR_CONTRACT = gql`
  mutation addCarContract(
    $document_number: String
    $document_date: String
    $document_type: String
    $inspection_center: String
    $seller_id: Int
    $buyer_id: Int
    $delivery_date: String
    $inspection_date: String
    $notes: String
    $delivered_items: String
    $car_type: String
    $car_color: String
    $current_tag: String
    $next_tag: String
    $motor_number: String
    $vin_number: String
    $barcode: String
    $insurance_company: String
    $insurance_id: String
    $insurance_unique_id: String
    $insurance_expire_date: String
    $price: String
    $prepayment: String
    $remained: String
    $cheques: String
    $profit: String
    $price_buy: String
    $payment_terms: String
    $is_closed: Boolean
    $chassis_number: String
    $manufacture_date: String
    $office: String
    $buyer_other_delivered_items: String
    $seller_other_delivered_items: String
  ) {
    addCarContract(
      document_number: $document_number
      document_date: $document_date
      document_type: $document_type
      inspection_center: $inspection_center
      seller_id: $seller_id
      buyer_id: $buyer_id
      delivery_date: $delivery_date
      inspection_date: $inspection_date
      notes: $notes
      delivered_items: $delivered_items
      car_type: $car_type
      car_color: $car_color
      current_tag: $current_tag
      next_tag: $next_tag
      motor_number: $motor_number
      vin_number: $vin_number
      barcode: $barcode
      insurance_company: $insurance_company
      insurance_id: $insurance_id
      insurance_unique_id: $insurance_unique_id
      insurance_expire_date: $insurance_expire_date
      price: $price
      prepayment: $prepayment
      remained: $remained
      cheques: $cheques
      profit: $profit
      price_buy: $price_buy
      payment_terms: $payment_terms
      is_closed: $is_closed
      chassis_number: $chassis_number
      manufacture_date: $manufacture_date
      office: $office
      buyer_other_delivered_items: $buyer_other_delivered_items
      seller_other_delivered_items: $seller_other_delivered_items
    ) {
      id
    }
  }
`;

export const MUTATION_EDIT_CAR_CONTRACT = gql`
  mutation editCarContract(
    $id: Int
    $document_number: String
    $document_date: String
    $document_type: String
    $inspection_center: String
    $seller_id: Int
    $buyer_id: Int
    $delivery_date: String
    $inspection_date: String
    $notes: String
    $delivered_items: String
    $car_type: String
    $car_color: String
    $current_tag: String
    $next_tag: String
    $motor_number: String
    $vin_number: String
    $barcode: String
    $insurance_company: String
    $insurance_id: String
    $insurance_unique_id: String
    $insurance_expire_date: String
    $price: String
    $prepayment: String
    $remained: String
    $cheques: String
    $profit: String
    $price_buy: String
    $payment_terms: String
    $is_closed: Boolean
    $chassis_number: String
    $manufacture_date: String
    $office: String
    $buyer_other_delivered_items: String
    $seller_other_delivered_items: String
  ) {
    editCarContract(
      id: $id
      document_number: $document_number
      document_date: $document_date
      document_type: $document_type
      inspection_center: $inspection_center
      seller_id: $seller_id
      buyer_id: $buyer_id
      delivery_date: $delivery_date
      inspection_date: $inspection_date
      notes: $notes
      delivered_items: $delivered_items
      car_type: $car_type
      car_color: $car_color
      current_tag: $current_tag
      next_tag: $next_tag
      motor_number: $motor_number
      vin_number: $vin_number
      barcode: $barcode
      insurance_company: $insurance_company
      insurance_id: $insurance_id
      insurance_unique_id: $insurance_unique_id
      insurance_expire_date: $insurance_expire_date
      price: $price
      prepayment: $prepayment
      remained: $remained
      cheques: $cheques
      profit: $profit
      price_buy: $price_buy
      payment_terms: $payment_terms
      is_closed: $is_closed
      chassis_number: $chassis_number
      manufacture_date: $manufacture_date
      office: $office
      buyer_other_delivered_items: $buyer_other_delivered_items
      seller_other_delivered_items: $seller_other_delivered_items
    ) {
      id
    }
  }
`;

export const MUTATION_ADD_CHEQUE = gql`
  mutation addChequeMutation(
    $giver_user_id: Int
    $reciver_user_id: Int
    $first_party_id: Int
    $second_party_id: Int
    $guarantor_id: Int
    $recommender_id: Int
    $amount: Float
    $bank: String
    $bank_branch: String
    $account: String
    $description: String
    $is_guarantee_cheque: Boolean
    $is_draft: Boolean
    $due_date: String
    $delivered_date: String
    $bounced_date: String
    $cashed_date: String
    $returned_date: String
    $chequeable_id: String
    $chequeable_type: String
    $cheque_id: String
    $transfered_date: String
    $recieverable_type: String
    $recieverable_id: String
    $icis: String
    $status: String
  ) {
    addChequeMutation(
      giver_user_id: $giver_user_id
      reciver_user_id: $reciver_user_id
      first_party_id: $first_party_id
      second_party_id: $second_party_id
      guarantor_id: $guarantor_id
      recommender_id: $recommender_id
      amount: $amount
      bank: $bank
      bank_branch: $bank_branch
      account: $account
      description: $description
      is_guarantee_cheque: $is_guarantee_cheque
      is_draft: $is_draft
      due_date: $due_date
      delivered_date: $delivered_date
      bounced_date: $bounced_date
      cashed_date: $cashed_date
      returned_date: $returned_date
      chequeable_id: $chequeable_id
      chequeable_type: $chequeable_type
      cheque_id: $cheque_id
      transfered_date: $transfered_date
      recieverable_type: $recieverable_type
      recieverable_id: $recieverable_id
      icis: $icis
      status: $status
    ) {
      id
    }
  }
`;

export const MUTATION_EDIT_CHEQUE = gql`
  mutation editChequeMutation(
    $id: Int
    $giver_user_id: Int

    $first_party_id: Int
    $second_party_id: Int
    $guarantor_id: Int
    $recommender_id: Int
    $amount: Float
    $bank: String
    $bank_branch: String
    $account: String
    $description: String
    $is_guarantee_cheque: Boolean
    $is_draft: Boolean
    $due_date: String
    $delivered_date: String
    $bounced_date: String
    $cashed_date: String
    $returned_date: String
    $chequeable_id: String
    $chequeable_type: String
    $cheque_id: String
    $transfered_date: String
    $recieverable_type: String
    $recieverable_id: String
    $icis: String
    $status: String
  ) {
    editChequeMutation(
      id: $id
      giver_user_id: $giver_user_id
      
      first_party_id: $first_party_id
      second_party_id: $second_party_id
      guarantor_id: $guarantor_id
      recommender_id: $recommender_id
      amount: $amount
      bank: $bank
      bank_branch: $bank_branch
      account: $account
      description: $description
      is_guarantee_cheque: $is_guarantee_cheque
      is_draft: $is_draft
      due_date: $due_date
      delivered_date: $delivered_date
      bounced_date: $bounced_date
      cashed_date: $cashed_date
      returned_date: $returned_date
      chequeable_id: $chequeable_id
      chequeable_type: $chequeable_type
      cheque_id: $cheque_id
      transfered_date: $transfered_date
      recieverable_type: $recieverable_type
      recieverable_id: $recieverable_id
      icis: $icis
      status: $status
    ) {
      id
    }
  }
`;

export const MUTATION_REMOVE_ATTACHMENT = gql`
  mutation removeAttachment($id: Int) {
    removeAttachment(id: $id)
  }
`;

export const MUTATION_REMOVE_USER = gql`
  mutation removeUser($id: Int) {
    removeUser(id: $id)
  }
`;

export const MUTATION_REMOVE_CAR_CONTRACT = gql`
  mutation removeCarContract($id: Int) {
    removeCarContract(id: $id)
  }
`;

export const MUTATION_REMOVE_DEBIT_CREDIT = gql`
  mutation removeDebtCredit($id: Int) {
    removeDebtCredit(id: $id)
  }
`;

export const MUTATION_REMOVE_BANK_ACCOUNT = gql`
  mutation removeBankAccount($id: Int) {
    removeBankAccount(id: $id)
  }
`;

export const MUTATION_REMOVE_CHEQUE_CONTRACT = gql`
  mutation removeChequeContract($id: Int) {
    removeChequeContract(id: $id)
  }
`;

export const MUTATION_REMOVE_CHEQUE = gql`
  mutation removeCheque($id: Int) {
    removeCheque(id: $id)
  }
`;

export const MUTATION_REMOVE_LEGAL_ENTITY = gql`
  mutation removeLegalEntity($id: Int) {
    removeLegalEntity(id: $id)
  }
`;

export const MUTATION_ADD_CHEQUE_CONTRACT = gql`
  mutation addChequeContract(
    $first_party_id: Int
    $second_party_id: Int
    $ratio: Float
    $description: String
    $is_signed: Boolean
    $is_closed: Boolean
    $agreement_date: String
    $origin_date: String
    $first_cheques: String
    $second_cheques: String
  ) {
    addChequeContract(
      first_party_id: $first_party_id
      second_party_id: $second_party_id
      ratio: $ratio
      description: $description
      is_closed: $is_closed
      is_signed: $is_signed
      agreement_date: $agreement_date
      origin_date: $origin_date
      first_cheques: $first_cheques
      second_cheques: $second_cheques
    ) {
      id
    }
  }
`;

export const MUTATION_EDIT_CHEQUE_CONTRACT = gql`
  mutation editChequeContract(
    $id: Int
    $first_party_id: Int
    $second_party_id: Int
    $ratio: Float
    $description: String
    $is_signed: Boolean
    $is_closed: Boolean
    $agreement_date: String
    $origin_date: String
    $first_cheques: String
    $second_cheques: String
  ) {
    editChequeContract(
      id: $id
      first_party_id: $first_party_id
      second_party_id: $second_party_id
      ratio: $ratio
      description: $description
      is_closed: $is_closed
      is_signed: $is_signed
      agreement_date: $agreement_date
      origin_date: $origin_date
      first_cheques: $first_cheques
      second_cheques: $second_cheques
    ) {
      id
    }
  }
`;

export const MUTATION_EDIT_SETTING = gql`
  mutation editSetting($id: Int, $value: String) {
    editSetting(id: $id, value: $value) {
      id
    }
  }
`;

export const MUTATION_ADD_DEBIT_CREDIT = gql`
  mutation addDebtCredit(
    $user_id: Int
    $amount: Float
    $remained: Float
    $status: String
    $type: String
    $cleared_at: String
    $date: String
    $about: String
    $description: String
  ) {
    addDebtCredit(
      user_id: $user_id
      amount: $amount
      remained: $remained
      status: $status
      cleared_at: $cleared_at
      type: $type
      date: $date
      about: $about
      description: $description
    ) {
      id
    }
  }
`;

export const MUTATION_EDIT_DEBIT_CREDIT = gql`
  mutation editDebtCredit(
    $id: Int
    $user_id: Int
    $amount: Float
    $remained: Float
    $status: String
    $type: String
    $cleared_at: String
    $date: String
    $about: String
    $description: String
  ) {
    editDebtCredit(
      id: $id
      user_id: $user_id
      amount: $amount
      remained: $remained
      status: $status
      cleared_at: $cleared_at
      type: $type
      date: $date
      about: $about
      description: $description
    ) {
      id
    }
  }
`;

export const MUTATION_ADD_BANK_ACCOUNT = gql`
  mutation addBankAccount(
    $user_id: Int
    $bank: String
    $branch: String
    $branch_code: String
    $account: String
    $ibn: String
    $card: String
    $description: String
  ) {
    addBankAccount(
      user_id: $user_id
      bank: $bank
      branch_code: $branch_code
      branch: $branch
      account: $account
      ibn: $ibn
      card: $card
      description: $description
    ) {
      id
    }
  }
`;

export const MUTATION_EDIT_BANK_ACCOUNT = gql`
  mutation editBankAccount(
    $id: Int
    $user_id: Int
    $bank: String
    $branch: String
    $branch_code: String
    $account: String
    $ibn: String
    $card: String
    $description: String
  ) {
    editBankAccount(
      id: $id
      user_id: $user_id
      bank: $bank
      branch_code: $branch_code
      branch: $branch
      account: $account
      ibn: $ibn
      card: $card
      description: $description
    ) {
      id
    }
  }
`;

export const MUTATION_ADD_LEGAL_ENTITY = gql`
  mutation addLegalEntity(
    $name: String
    $email: String
    $website: String
    $phone: String
    $mobile: String
    $address: String
    $description: String
    $register_no: String
    $national_code: String
  ) {
    addLegalEntity(
      name: $name
      email: $email
      phone: $phone
      website: $website
      mobile: $mobile
      address: $address
      description: $description
      national_code: $national_code
      register_no: $register_no
    ) {
      id
    }
  }
`;

export const MUTATION_EDIT_LEGAL_ENTITY = gql`
  mutation editLegalEntity(
    $id: Int
    $name: String
    $email: String
    $website: String
    $phone: String
    $mobile: String
    $address: String
    $description: String
    $register_no: String
    $national_code: String
  ) {
    editLegalEntity(
      id: $id
      name: $name
      email: $email
      phone: $phone
      website: $website
      mobile: $mobile
      address: $address
      description: $description
      national_code: $national_code
      register_no: $register_no
    ) {
      id
    }
  }
`;
